import type { ReactNode } from 'react';

export const symbol_sound_detection_loud_sound: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M483-256 355-128q-17 17-42.5 17T270-128L129-270q-17-17-17-42t17-42l127-128v-153q0-20 18.5-27.5T307-656l350 349q14 14 6 32.5T635-256H483Zm78-60L316-559v102L171-312l141 141 145-145h104Zm131-377q-66-66-155.5-82T362-755q-11 5-23 .5T323-770q-5-13 .5-25.5T342-813q100-42 207-22t186 99q78 78 98.5 182.5T815-350q-5 14-18 22t-27 3q-12-4-15.5-16t1.5-25q35-84 18-173t-82-154Zm-84 85q22 22 35 50t16 59q1 12-8.5 20t-21.5 7q-12-1-21-10t-11-21q-3-17-10.5-33T566-565q-13-13-28.5-21T505-597q-13-2-21.5-10.5T475-629q0-13 8.5-22.5T505-659q29 4 55.5 17t47.5 34ZM366-365Z"
		/>
	</svg>
);
